
import Toggle from './toggle'

export default Toggle



// WEBPACK FOOTER //
// ./src/components/toggle/index.js